import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const opsGenie = defineConnector({
  identifier: "opsGenie",
  name: "Opsgenie",
  tagLine: "Incident management",
  keywords:
    "ops genie atlassian oncall on call alerts paging escalation heartbeats",
  logo,
  protocol: "http",
  tags: ["it", "observability"],
  defaultUrlPattern: () => "https://api\\.opsgenie\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "GenieKey",
      },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Opsgenie](https://www.atlassian.com/software/opsgenie) and sign in. Navigate to **Settings > API key management** to create a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Opsgenie API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.opsgenie.com/v2/heartbeats",
  },
});
